
export const generateSubmissionIdentifier = () => {
  return `submission-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
};

export const getRedirectUrl = (): string => {
  // For production, use the window's origin
  return `${window.location.origin}/auth-callback`;
};

export const normalizeAlternativeEmails = (emails?: string | string[]): string[] => {
  if (!emails) return [];
  if (typeof emails === 'string') {
    const trimmed = emails.trim();
    return trimmed ? [trimmed] : [];
  }
  
  if (Array.isArray(emails)) {
    return emails.filter(e => e && typeof e === 'string' && e.trim()).map(e => e.trim());
  }
  
  return [];
};

export const generateStableIdentifier = (
  email: string,
  organisationId?: string,
  draftId?: string,
  customIdentifier?: string
): string => {
  if (customIdentifier) return customIdentifier;
  if (organisationId) return `org_${organisationId}`;
  if (draftId) return `draft_${draftId}`;
  
  // Generate a stable identifier based on email and current timestamp
  // This ensures we can find the session later
  return `submission_${email}_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;
};

// Function to get the submissionIdentifier from URL or sessionStorage
export const getSubmissionIdentifier = (urlParams: URLSearchParams): string => {
  const submissionId = urlParams.get('submission_identifier');
  if (submissionId) return submissionId;

  // Try to get from sessionStorage
  const storedId = sessionStorage.getItem('figabl_submission_identifier');
  if (storedId) return storedId;

  return 'default';
};
